"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardEvents = exports.BoardEventKind = void 0;
const nanoid_1 = require("nanoid");
const BoardEntity_1 = require("../../data/BoardEntity");
var BoardEventKind;
(function (BoardEventKind) {
    BoardEventKind["NewHand"] = "poker:board:new_hand";
    BoardEventKind["DealtHoleCards"] = "poker:board:dealt_hole_cards";
    BoardEventKind["DealtFlop"] = "poker:board:dealt_flop";
    BoardEventKind["DealtTurn"] = "poker:board:dealt_turn";
    BoardEventKind["DealtRiver"] = "poker:board:dealt_river";
    BoardEventKind["Showdown"] = "poker:board:showdown";
    BoardEventKind["BetsToPot"] = "poker:board:bets_moved_to_pot";
    BoardEventKind["CreateSidePot"] = "poker:board:create_sidepot";
})(BoardEventKind = exports.BoardEventKind || (exports.BoardEventKind = {}));
class BoardEvents {
    static newHandEvent(board) {
        return BoardEvents.createEvent(BoardEventKind.NewHand, board);
    }
    static dealtHoleCardsEvent(board) {
        return BoardEvents.createEvent(BoardEventKind.DealtHoleCards, board);
    }
    static dealtFlop(board) {
        return BoardEvents.createEvent(BoardEventKind.DealtFlop, board);
    }
    static dealtTurn(board) {
        return BoardEvents.createEvent(BoardEventKind.DealtTurn, board);
    }
    static dealtRiver(board) {
        return BoardEvents.createEvent(BoardEventKind.DealtRiver, board);
    }
    static showdown(board) {
        return BoardEvents.createEvent(BoardEventKind.Showdown, board);
    }
    static betsToPot(board) {
        return BoardEvents.createEvent(BoardEventKind.BetsToPot, board);
    }
    static createSidePot(board) {
        return BoardEvents.createEvent(BoardEventKind.CreateSidePot, board);
    }
    static createEvent(eventKind, board) {
        return {
            id: nanoid_1.nanoid(),
            kind: eventKind,
            timestamp: Date.now(),
            board: BoardEntity_1.BoardEntity.createFromBoard(board),
        };
    }
}
exports.BoardEvents = BoardEvents;
//# sourceMappingURL=BoardEvent.js.map